module.exports = __webpack_public_path__ + "img/photo-0007.da5a669e.jpg";